var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class":
          "v-application v-application--is-ltr acceptance-comment-dialog",
        "max-width": "780px",
        fullscreen: !_vm.$vuetify.breakpoint.mdAndUp,
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "rounded v-application",
          attrs: { outlined: "", elevation: "0" },
        },
        [
          _c("v-card-title", [_vm._v("Geolokalisierung aktualisieren")]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticStyle: { "overflow-y": "auto", flex: "1 1 auto" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "9" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.searchResults,
                          label: "Suche Apotheke",
                          "no-data-text":
                            "Geben Sie ein, um Suchergebnisse zu erhaltenKeine Suchergebnisse",
                          loading: _vm.isLoading,
                          chips: "",
                          multiple: "",
                          "no-filter": "",
                          "return-object": "",
                        },
                        on: {
                          "update:search-input": (term) =>
                            _vm.searchPharmacies(term),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "v-application",
                                    attrs: {
                                      "data-role": "pharmacy-option",
                                      "data-pharmacy-id": item._id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-medium mt-2 no-margin pharmacy-name",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(item.name) +
                                            " (" +
                                            _vm._s(item.city) +
                                            ")\n                                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.selectedPharmacies,
                          callback: function ($$v) {
                            _vm.selectedPharmacies = $$v
                          },
                          expression: "selectedPharmacies",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-end pa-4" },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      _vm.isOpen = false
                    },
                  },
                },
                [_vm._v("Abbrechen")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: !_vm.selectedPharmacies.length,
                    color: "success",
                    loading: _vm.isLoading,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("\n                Speichern\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }